import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, useNotify } from 'react-admin';
import {
    AppResourceContext,
    AppResourceType,
    getAppDeepLink,
} from './getAppDeepLink';

export const CopyAppLinkButton = ({
    type,
    id,
    context,
    label = 'Copy app link',
}: {
    type: AppResourceType;
    id: string;
    context?: AppResourceContext;
    label?: string;
}) => {
    const notify = useNotify();

    const handleClick = () => {
        try {
            const url = getAppDeepLink(type, id, context);
            void navigator.clipboard
                .writeText(url)
                .then(() => {
                    notify('App link copied to clipboard', { type: 'info' });
                })
                .catch(error => {
                    console.error(error);
                    notify('Could not copy app link', { type: 'error' });
                });
        } catch (error) {
            console.error(error);
            notify(
                error instanceof Error
                    ? error.message
                    : 'Could not build app link',
                { type: 'error' }
            );
        }
    };

    return (
        <Button
            onClick={handleClick}
            startIcon={<ContentCopyIcon />}
            size="small"
            label={label}
        />
    );
};
